export default (theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: 0,
    color: "#525252",
  },
  dialogPaper: {
    minHeight: "300px",
  },
  panelTitle: {
    fontSize: "1rem",
    fontWeight: "600",
  },
});
